<template>
  <archives-list v-if="selectedMsp.id" :tier="tierType" :id="selectedMsp.id" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ArchivesList from "@/views/Common/AttachmentFilters/PasswordProtectedArchive.vue";

import { TIER } from "@/constants";

export default {
  name: "PasswordProtectedArchives",
  components: {
    ArchivesList,
  },
  data() {
    return {
      tierType: TIER.msps,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedMsp"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Attachments"));
    this.setPageSubtitle([]);
  },
};
</script>
